import authorizedRequest from 'helpers/request/authorizedRequest';
import config from '../configs/index';

export async function handleCallTestApi(params: { patientUuid: string }) {
  const callService = await authorizedRequest.post(
    `${config.BASE_CALL_URL}/openmrs/ws/rest/v1/calltest/${params.patientUuid}`,
  );
  return callService;
}
